import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Page 404 client (noindex via routes-meta : chemin inconnu -> noindex).
// NB : le code HTTP réel reste 200 sur l'hébergement statique (voir SEO-NON-COUVERT.md).
export default function NotFound() {
  return (
    <div>
      <Seo path="/404" title="Page introuvable | VIRALYA" description="Cette page n'existe pas ou a été déplacée." noCanonical />
      <Header />
      <main className="page">
        <div className="container page-narrow" data-testid="notfound-page">
          <span className="eyebrow"><span className="sq" />Erreur 404</span>
          <h1 className="h2" style={{ marginBottom: "0.5rem" }}>Cette page n'existe pas</h1>
          <p className="lead" style={{ marginBottom: "1.5rem", maxWidth: "52ch" }}>
            Le lien est peut-être erroné ou la page a été déplacée. Revenez à l'accueil pour retrouver votre chemin.
          </p>
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
            <Link to="/" className="btn btn--primary" data-testid="notfound-home"><ArrowLeft size={15} /> Retour à l'accueil</Link>
            <Link to="/pilote" className="btn btn--ghost" data-testid="notfound-pilote">Lancer un pilote</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
